import styled from 'styled-components';
import { palette } from 'styled-theme';
import logo from '../../image/signup_graphic.png';
import WithDirection from '../../config/withDirection';

const SignInStyleWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  display: block;
  position: relative;
  background: #EBF2F7;

  // &:before {
  //   content: '';
  //   width: 100%;
  //   height: 100%;
  //   display: flex;
  //   position: absolute;
  //   z-index: 1;
  //   top: 0;
  //   left: ${props => (props['data-rtl'] === 'rtl' ? 'inherit' : '0')};
  //   right: ${props => (props['data-rtl'] === 'rtl' ? '0' : 'inherit')};
  // }

  .header, .content {
    width: 100%;
  }

  .content {
    // padding-bottom: 40px;
    padding-top: 10px;


  }
  .bg-img{
             background-image: url(${logo});
         background-size: cover;
         background-repeat: no-repeat;
             position: absolute;
    min-height: calc(100vh - 0px);
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
  }

  .header{
    background: #fff;
    height:60px;
    padding: 0 40px;
    border-bottom: 1px solid #dbdbdb;
    @media only screen and (min-width: 2400px) {
      height:120px;
      padding: 0 80px;
    }
    a {
      font-size: 24px;
      font-weight: 300;
      line-height: 1;
      //text-transform: uppercase;
      color: ${palette('secondary', 2)};
      display:block;
      padding:4px 0;
      @media only screen and (max-width: 767px) {
        width: 100%;
        text-align: center;
      }
      @media only screen and (min-width: 2400px) {
        font-size: 48px;
        font-weight: 300;
        line-height: 2;
      }
    }
  }

  .isoLoginContentWrapper {
    width: 470px;
    // overflow-y: auto;
    z-index: 10;
    position: relative;
    margin: 8px auto 0;
    // border: 1px solid #eee;
    box-shadow: 1px #eee;
    border-radius: 7px;
    &.hide {
      display:none;
    }
    &.show {
      display:block;
    }
    &.personalInfo {
      // width: 600px;
    }
    @media only screen and (max-width: 375px) {
      width: 300px;
    }
    @media only screen and (max-width: 768px) {
      width: auto !important;
      margin: 40px auto 0;
      
    }
    @media only screen and (min-width: 2400px) {
      width: 800px;
      &.personalInfo {
        width: 1600px;
      }
    }
  }

  .isoLoginContent {
    display: flex;
    flex-direction: column;
    padding: 0 20px 20px;
    position: relative;
    background-color: #ffffff;
    
    @media only screen and (max-width: 767px) {
      width: 100%;
      
    }
    @media only screen and (min-width: 2400px) {
      padding: 40px;
    }

    .isoLogoWrapper {
      width: 100%;
      display: flex;
      font-size: 20px;
      flex-shrink: 0;
      margin: 5px 0 15px 5px;
      line-height: 1;
      text-transform: capitalize;
      @media only screen and (min-width: 2400px) {
        margin: 30px 0 50px 0;
        font-size: 68px;
      }
    }
    
    .isoPlanInfoWrapper{
    padding: 20px 30px;
    border: solid 1px #EEE;
    border-radius: 5px;
    position: relative;
    .isoPlanInfoTitle{
        font-size: 16px;
        font-weight: 500;
        color: #010101;
        margin: 5px;
    }
    .isoPlanInfoDescription{
        font-size: 14px;
        font-weight: 400;
        margin: 5px;
    }
    .isoPlanInfoLink{
        margin: 5px;
        font-size: 14px;
        font-weight: 700;
        position: absolute;
    top: 15px;
    right: 20px;
    }
    }

    .isoSignInForm {
      width: 100%;
      display: flex;
      flex-shrink: 0;
      flex-direction: column;
      transition: width 500ms 0ms, display 500ms 500ms;
      
      &.hide {
        transition: width 500ms 500ms, display 500ms 0ms;
        opacity: 0.0;
        width: 0px;
        display: none;
      }
      &.show {
        transition: width 500ms 0ms, display 500ms 500ms;
        opacity: 1;
        width: 100%;
        display: block;
        .qrImg {
          display:block;
          margin: 0 auto 20px;
        }
      }
     

      .isoInputWrapper {
        margin-bottom: 5px;
        .ant-input.ant-input-lg{
            height: 40px;
        }
        .ant-form-item{
        margin-bottom:8px;
        }
        .ant-form-explain{
        text-align:left;
        }
        @media only screen and (min-width: 2400px) {
          margin-bottom: 30px;
          strong {
            font-size: 28px;
          }
        }
        &:last-of-type {
          margin-bottom: 0;
        }

        input {
          &::-webkit-input-placeholder {
            color: ${palette('grayscale', 0)};
          }

          &:-moz-placeholder {
            color: ${palette('grayscale', 0)};
          }

          &::-moz-placeholder {
            color: ${palette('grayscale', 0)};
          }
          &:-ms-input-placeholder {
            color: ${palette('grayscale', 0)};
          }
          @media only screen and (min-width: 2400px) {
            height: 84px;
            padding: 12px 20px;
            font-size: 26px;
            line-height: 3;
          }
        }
      }

      .isoHelperText {
        font-size: 12px;
        font-weight: 400;
        line-height: 1.2;
        color: ${palette('grayscale', 1)};
        padding-left: ${props =>
          props['data-rtl'] === 'rtl' ? 'inherit' : '13px'};
        padding-right: ${props =>
          props['data-rtl'] === 'rtl' ? '13px' : 'inherit'};
        margin: 15px 0;
        position: relative;
        display: flex;
        align-items: center;

        &:before {
          content: '*';
          color: ${palette('error', 0)};
          padding-right: 3px;
          font-size: 14px;
          line-height: 1;
          position: absolute;
          top: 2px;
          left: ${props => (props['data-rtl'] === 'rtl' ? 'inherit' : '0')};
          right: ${props => (props['data-rtl'] === 'rtl' ? '0' : 'inherit')};
        }
      }

      .isoHelperWrapper {
        display:block;
        text-align:right;
        a {
          @media only screen and (min-width: 2400px) {
            font-size: 28px;
            line-height: 3;
          }
        }
      }

      .isoOtherLogin {
        padding-bottom: 35px;
        margin-bottom: 35px;
        border-bottom: 1px dashed ${palette('grayscale', 2)};
        @media only screen and (min-width: 2400px) {
          padding-bottom: 70px;
          margin-bottom: 70px;
        }
        > a {
          display: flex;
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }
        }

        button {
          width: 48%;
          height: 42px;
          border: 0;
          font-weight: 500;
          margin: 0 1%;
          padding: 0 10px;
          
          @media only screen and (max-width: 786px) {
            width: 100%;
            padding: 0 25px;
          }
          @media only screen and (min-width: 2400px) {
            padding: 0 20px;
            font-size: 28px;
            line-height: 3;
            height: 84px;
          }

          &.btnFacebook {
            background: #3b5998;

            &:hover {
              background: darken(#3b5998, 5%);
            }
          }

          &.btnGooglePlus {
            background: #dd4b39;
            margin-top: 15px;

            &:hover {
              background: darken(#dd4b39, 5%);
            }
          }

          &.btnAuthZero {
            background-color: #e14615;
            margin-top: 15px;

            &:hover {
              background-color: darken(#e14615, 5%);
            }
          }

          &.btnFirebase {
            background-color: ${palette('color', 5)};
            margin-top: 15px;

            &:hover {
              background-color: ${palette('color', 6)};
            }
          }
        }
      }

      .isoForgotPass {
        font-size: 12px;
        color: ${palette('text', 3)};
        margin-bottom: 10px;
        text-decoration: none;

        &:hover {
          color: ${palette('primary', 0)};
        }
      }

      button {
        font-weight: 500;
      }
    }
  }

  @media only screen and (min-width: 2400px) {
    .ant-checkbox-inner, .ant-radio-inner {
      width: 32px;
      height: 32px;
    }
    .ant-checkbox-inner {
      &:after {
        left: 11px;
        top: 2px;
        width: 10px;
        height: 18px;
      }
    }
    .ant-radio-inner {
      &:after {
        width: 24px;
        height: 24px;
        border-radius: 16px;
      }
    }
    .ant-checkbox-wrapper + span, .ant-checkbox + span, .ant-radio-wrapper + span, .ant-radio + span {
      padding-left: 16px;
      padding-right: 16px;
      font-size: 26px;
    }
    .ant-btn-primary {
      line-height: 72px;
      padding: 0 30px;
      font-size: 28px;
      border-radius: 8px;
      height: 72px;
    }
  }

  .ant-select-selection--single {
    height:41px;
  }
  .successSignup {
    .anticon {
      top: 22px;
      font-size: 16px;
    }
    .ant-alert-message {
      font-size: 24px;
    }
  }
  .react-phone-number-input {
    padding: 3px !important;
    .react-phone-number-input__icon-image {
      display:inherit;
    }
    input {
      border-bottom: none;
      font-size: 14px;
    }
  }
`;

export default WithDirection(SignInStyleWrapper);
